import { Routes } from '@angular/router';
import { authGuard } from './guard/auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/pages/login-page/login-page.component').then(m => m.LoginPageComponent),
  },
  {
    path: 'declarations',
   canActivate: [authGuard],
    loadComponent: () =>
      import('./features/pages/declarations-page/declarations-page.component').then(m => m.DeclarationsPageComponent),
  },
  {
    path: 'pictures/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/pages/pictures-page/pictures-page.component').then(m => m.PicturesPageComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
